module.exports = __webpack_public_path__ + "static/prototype-b06facc5aa212a4776a70aeed70ebfb7.png";